







export default {
  data() {
    return {}
  },
  methods: {
    // 点击下载
    handelDownload() {
      if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
        // 如果用户已经安装App直接跳转App
        window.location.href = 'allo.ios.app://'
        // 如果用户打开App失败，直接跳转下载
        setTimeout(function() {
          window.location.href = 'https://itunes.apple.com/app/1664635935'
        }, 3000)
      } else if (/(Android)/i.test(navigator.userAgent)) {
        // 如果用户已经安装App直接跳转App
        window.location.href = 'allo://tel.top/home/callshow?select=0'
        // 如果用户打开App失败，直接跳转下载
        setTimeout(function() {
          window.location.href = process.env.VUE_APP_ALLO
        }, 3000)
      } else {
        window.location.href = process.env.VUE_APP_ALLO
      }
    }
  }
}
